export const DOMAIN_PSAS = "PSAS";
